import React, { useState, useContext } from 'react'
import { ViewListIcon, ChartBarIcon, DownloadIcon } from '@heroicons/react/outline'

import ImportedFiles from './components/ImportedFiles'
import './components/Form.scss'
import UploadForm from './components/UploadForm'
import { AuthContext } from 'stores/auth'

const FormView = () => {
  const [datafeed, setDatafeed] = useState(null)
  const [viewImportedFiles, setViewImportedFiles] = useState(false)
  const authStore = useContext(AuthContext)

  let user = authStore.user
  let scope  = user?.profile?.scope || authStore.scope

  if (!scope || !user) {
    return null
  }

  return (
    <>
      <div className="flex flex-1 min-h-full">
        <div className="p-6 flex-1">
          <div className="mb-2 md:flex md:items-center md:justify-between">
            <div className="flex-1 min-w-0">
              <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Claiming</h2>
            </div>
            <div className="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
            <button
                className='inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-600 bg-gray-200 hover:bg-gray-300 focus:outline-none'
                onClick={() => {
                  setViewImportedFiles(!viewImportedFiles)
                }}
              >{viewImportedFiles
                ? (<>Hide Submissions<ViewListIcon className="ml-2 h-4 w-4" aria-hidden="true" /></>)
                : (<>View Submissions<ViewListIcon className="ml-2 h-4 w-4" aria-hidden="true" /></>)
              }</button>
              <a
                className='ml-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-600 bg-gray-200 hover:bg-gray-300 focus:outline-none'
                href='/claiming/stats'
              >
                View Stats<ChartBarIcon className="ml-2 h-4 w-4" aria-hidden="true" />
              </a>
              <a
                className='ml-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-600 bg-gray-200 hover:bg-gray-300 focus:outline-none'
                href='/claiming/export'
              >
                Export<DownloadIcon className="ml-2 h-4 w-4" aria-hidden="true" />
              </a>
            </div>
          </div>
          <div>
            <UploadForm
              datafeed={datafeed} />
            <br />
            {viewImportedFiles && <ImportedFiles propScope={scope} propUser={user} />}
          </div>
        </div>
      </div>
    </>
  )
}

export default FormView
